module.exports = require("lodash/assignIn");